__turbopack_context__.v({
  "collapsible": "LinksGridSection-module-scss-module__WUmnOa__collapsible",
  "content": "LinksGridSection-module-scss-module__WUmnOa__content",
  "cta": "LinksGridSection-module-scss-module__WUmnOa__cta",
  "excerpt": "LinksGridSection-module-scss-module__WUmnOa__excerpt",
  "heading": "LinksGridSection-module-scss-module__WUmnOa__heading",
  "icon": "LinksGridSection-module-scss-module__WUmnOa__icon",
  "icon--new-tab": "LinksGridSection-module-scss-module__WUmnOa__icon--new-tab",
  "link": "LinksGridSection-module-scss-module__WUmnOa__link",
  "list": "LinksGridSection-module-scss-module__WUmnOa__list",
  "list-item": "LinksGridSection-module-scss-module__WUmnOa__list-item",
  "pdf": "LinksGridSection-module-scss-module__WUmnOa__pdf",
  "slide-down": "LinksGridSection-module-scss-module__WUmnOa__slide-down",
  "slide-up": "LinksGridSection-module-scss-module__WUmnOa__slide-up",
  "top-list": "LinksGridSection-module-scss-module__WUmnOa__top-list",
});
